import { USDollar } from 'utils/format';
import arrowLeft from '../assets/img/arrowLeft.png';
import arrowRight from '../assets/img/arrowRight.png';
import { useEffect, useState, useContext } from 'react';
import { isAdmin, isInvestor, isSale, thirtyDaysFromNow } from 'utils/util';
import { EditFilled, CheckOutlined } from '@ant-design/icons';
import api from 'api';
import { sendEmail, sevenDaysFromNow } from 'utils/util';
import { Select, Space, Spin, message } from 'antd';
import { get } from 'utils/fetch';
import { GlobalContext } from 'GlobalContext';
import { PrincipalSumErrorConfirmation } from 'ConfirmationPages/PrincipalSumErrorConfirmation';
import { CloseInvestmentConfirmation } from 'ConfirmationPages/CloseInvestmentConfirmation';
import { getTodayDateString } from 'utils/util';
import { NoticeEmail } from 'pages/Email/NoticeEmail';
import { EmailResultBox } from 'pages/Email/EmailResultBox';
import { formatCurrency } from 'utils/format';

export function TransactionGallery(props) {
    const {
        transactions: initialTransactions,
        basicInfo,
        accountId,
        accountName,
        investment_id,
        refreshPage,
    } = props;
    const {
        accessToken,
        setEmailNoticeTransactionId,
        emailNoticeTransactionId,
        refreshSession,
    } = useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const timezoneOffset = 'T00:00:00-07:00';
    const [curPageIdx, setCurPageIdx] = useState(0);
    const [loading, setLoading] = useState(true);
    const [investors, setInvestors] = useState([]);
    const [showErrorbox, setShowErrorbox] = useState(false);
    const [showCloseConfirmationBox, setShowCloseConfirmationBox] =
        useState(false);
    const [emailResponse, setEmailResponse] = useState('');
    const [transactions, setTransactions] = useState(
        isAdmin() || isSale()
            ? initialTransactions
            : initialTransactions.filter(
                  (transaction) =>
                      new Date(transaction.timestamp + timezoneOffset) <=
                      new Date()
              )
    );

    var id2PaidDate = {};
    var curDateEditMode = {};
    for (const transaction of initialTransactions) {
        id2PaidDate[transaction.id] = transaction.paid_timestamp;
        curDateEditMode[transaction.id] = false;
    }
    const [dateEditMode, setDateEditMode] = useState(curDateEditMode);
    const [id2PaidDateMap, setId2PaidDateMap] = useState(id2PaidDate);
    // toggle email variables
    const [curPaymentState, setCurPaymentState] = useState(''); // paid or unpaid for current transaction action
    // id of the transaction that the email is about, replaced by setEmailNoticeTransactionId
    // const [curTransactionId, setCurTransactionId] = useState(-1)
    const [curTransactionType, setCurTransactionType] = useState(''); // type of the transaction the email is about
    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchEmailsByAccountId(id) {
        await get(
            api.manager.investorsByAccount(id),
            setInvestors,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        setLoading(false);
        refreshSession();
    }

    useEffect(() => {
        if (accessToken === '') return;
        fetchEmailsByAccountId(accountId);
    }, [accountId, accessToken]);

    // console.log(investment_id)
    function isFirstPage() {
        return curPageIdx === 0;
    }

    function isLastPage() {
        return (curPageIdx + 1) * 10 + 1 > transactions.length;
    }

    const curTransaction = transactions.slice(
        curPageIdx * 10,
        curPageIdx * 10 + 10
    );

    async function setPaidDate(transactionId, paidDate) {
        await fetch(api.transaction.setPaidDate(transactionId), {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                paidDate,
            }),
        });
        refreshSession();
        refreshPage();
    }

    const handleStatusChange = async (transaction, idx, email, name, type) => {
        const updatedStatus =
            transaction.transaction_status === 'unpaid' ? 'paid' : 'unpaid';
        if (updatedStatus.toLowerCase() === 'paid') {
            setId2PaidDateMap({
                ...id2PaidDateMap,
                [transaction.id]: getTodayDateString(),
            });
        } else {
            setId2PaidDateMap({ ...id2PaidDateMap, [transaction.id]: '' });
        }
        const response = await fetch(
            api.transaction.setStatus(transaction.id),
            {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    status: updatedStatus,
                }),
            }
        );
        refreshSession();
        // # unpaid entry
        const data = await response.json();
        const unpaidEntryCount = data.data;
        // console.log("unpaidEntryCount", unpaidEntryCount)
        if (unpaidEntryCount === -2) {
            // update status failed, don't update ui status and don't send email
            return;
        }

        const updatedTransactions = [...transactions];
        updatedTransactions[idx + curPageIdx * 10].transaction_status =
            updatedStatus;
        setTransactions(updatedTransactions);
        // buttonText, amount, email, name, type

        if (unpaidEntryCount >= 0) {
            // sendEmail(updatedStatus === "paid" ? "Pay" : "Unpay", transaction.amount, email, name, type);
            // send email
            if (
                updatedStatus === 'paid' &&
                (transaction.type.toLowerCase() === 'interest' ||
                    transaction.type.toLowerCase() === 'final payout')
            ) {
                // send notice
                setCurPaymentState(updatedStatus); // paid or unpaid for current transaction action
                setEmailNoticeTransactionId(transaction.id); // id of the transaction that the email is about
                setCurTransactionType(transaction.type.toLowerCase());
            }
        }

        if (unpaidEntryCount > 0) {
            // refreshPage()
        } else if (unpaidEntryCount === 0) {
            // pop up prompt to close investment
            setShowCloseConfirmationBox(true);
        } else if (unpaidEntryCount === -1) {
            // error in summation of principals
            // pop up prompt to contact developer
            setShowErrorbox(true);
        }
    };

    async function closeInvestmentCallback() {
        await fetch(api.manager.closeInvestment(investment_id), {
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        refreshSession();
        refreshPage();
    }

    // when close email interface, reset transactionType, emailNoticeTransactionId
    function resetState() {
        setEmailNoticeTransactionId(-1);
        setCurTransactionType('');
        setCurPaymentState('');
    }

    return (
        <>
            {loading && (
                <div style={{ marginLeft: '70px' }}>
                    <Spin />
                </div>
            )}

            {emailNoticeTransactionId >= 0 && (
                <NoticeEmail
                    setEmailResponse={setEmailResponse}
                    transactionId={emailNoticeTransactionId}
                    transactionType={curTransactionType}
                    resetState={resetState}
                />
            )}

            {emailResponse && <EmailResultBox emailResponse={emailResponse} />}

            {!loading && (
                <div>
                    {showCloseConfirmationBox && (
                        <CloseInvestmentConfirmation
                            setShowCloseConfirmationBox={
                                setShowCloseConfirmationBox
                            }
                            closeInvestmentCallback={closeInvestmentCallback}
                        />
                    )}
                    {showErrorbox && (
                        <PrincipalSumErrorConfirmation
                            setShowErrorbox={setShowErrorbox}
                        />
                    )}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                position: 'relative',
                                left: '15px',
                                zIndex: isFirstPage() ? '0' : '1',
                                cursor: isFirstPage() ? 'auto' : 'pointer',
                            }}
                            onClick={() =>
                                !isFirstPage() && setCurPageIdx(curPageIdx - 1)
                            }
                        >
                            <img
                                style={{
                                    display: isFirstPage() ? 'none' : 'flex',
                                }}
                                src={arrowLeft}
                            ></img>
                        </div>
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            {curTransaction.map((transaction, idx) => (
                                <li
                                    style={{
                                        color:
                                            transaction.transaction_status.toLowerCase() ===
                                            'unpaid'
                                                ? 'gray'
                                                : 'black',
                                        margin: 0,
                                        display: 'flex',
                                    }}
                                    key={transaction.id}
                                >
                                    <div
                                        style={{
                                            width: '100px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {transaction.timestamp}
                                    </div>
                                    <div
                                        style={{
                                            width: '100px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {/* paid date not in edit mode */}
                                        {!dateEditMode[transaction.id] &&
                                            id2PaidDateMap[transaction.id]}

                                        {/* paid date in edit mode */}
                                        {dateEditMode[transaction.id] && (
                                            <input
                                                type="date"
                                                max="9999-12-31"
                                                style={{
                                                    width: '87px',
                                                    fontSize: '12px',
                                                }}
                                                value={
                                                    id2PaidDateMap[
                                                        transaction.id
                                                    ]
                                                }
                                                onChange={(e) =>
                                                    setId2PaidDateMap(
                                                        (prevDateMap) => ({
                                                            ...prevDateMap,
                                                            [transaction.id]:
                                                                e.target.value,
                                                        })
                                                    )
                                                }
                                            ></input>
                                        )}

                                        {/* change paid date status to edit mode */}
                                        {isAdmin() &&
                                            id2PaidDateMap[transaction.id] &&
                                            !dateEditMode[transaction.id] && (
                                                <EditFilled
                                                    onClick={(e) =>
                                                        setDateEditMode(
                                                            (prevEditMode) => ({
                                                                ...prevEditMode,
                                                                [transaction.id]: true,
                                                            })
                                                        )
                                                    }
                                                />
                                            )}

                                        {/* change paid date status back to original mode */}
                                        {isAdmin() &&
                                            id2PaidDateMap[transaction.id] &&
                                            dateEditMode[transaction.id] && (
                                                <CheckOutlined
                                                    onClick={(e) => {
                                                        setPaidDate(
                                                            transaction.id,
                                                            id2PaidDateMap[
                                                                transaction.id
                                                            ]
                                                        );
                                                        setDateEditMode(
                                                            (prevEditMode) => ({
                                                                ...prevEditMode,
                                                                [transaction.id]: false,
                                                            })
                                                        );
                                                    }}
                                                />
                                            )}
                                    </div>
                                    <div
                                        style={{
                                            width: '100px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {formatCurrency(
                                            transaction.amount,
                                            transaction.currency
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            width: '100px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {transaction.type
                                            .charAt(0)
                                            .toUpperCase() +
                                            transaction.type.slice(1)}
                                    </div>

                                    <div
                                        style={{
                                            width: '100px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {transaction.transaction_status
                                            .charAt(0)
                                            .toUpperCase() +
                                            transaction.transaction_status.slice(
                                                1
                                            )}
                                    </div>

                                    {/* ----------------------------------------------------------------- */}
                                    {isAdmin() &&
                                        transaction.transaction_status.toLowerCase() !==
                                            'reinvest' &&
                                        new Date(
                                            transaction.timestamp +
                                                timezoneOffset
                                        ) <= thirtyDaysFromNow() && (
                                            <div
                                                style={{
                                                    width: '100px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <button
                                                    style={{
                                                        background:
                                                            transaction.transaction_status ===
                                                            'unpaid'
                                                                ? '#10b981'
                                                                : '#ef4444', // "rgb(17 32 86)",
                                                        color: 'white',
                                                        borderRadius: '5px',
                                                    }}
                                                    onClick={() =>
                                                        handleStatusChange(
                                                            transaction,
                                                            idx,
                                                            investors.map(
                                                                (investor) =>
                                                                    investor.email
                                                            ),
                                                            accountName,
                                                            transaction.type.toLowerCase()
                                                        )
                                                    }
                                                >
                                                    {transaction.transaction_status ===
                                                    'unpaid'
                                                        ? 'Pay'
                                                        : 'Unpay'}
                                                </button>
                                            </div>
                                        )}
                                </li>
                            ))}
                        </div>

                        <div
                            style={{
                                width: '30px',
                                height: '30px',
                                display: isLastPage() ? 'none' : 'flex',
                                position: 'relative',
                                right: '15px',
                                zIndex: isLastPage() ? '0' : '1',
                                cursor: isLastPage() ? 'auto' : 'pointer',
                            }}
                            onClick={() =>
                                !isLastPage() && setCurPageIdx(curPageIdx + 1)
                            }
                        >
                            <img src={arrowRight}></img>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
